import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";
import { setAccessToken, getAccessToken } from "./api";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Belt colors mapping
export const BELT_COLORS = {
  white: { bg: 'bg-white', text: 'text-zinc-900', border: 'border-zinc-300' },
  blue: { bg: 'bg-blue-500', text: 'text-white', border: 'border-blue-400' },
  purple: { bg: 'bg-purple-500', text: 'text-white', border: 'border-purple-400' },
  brown: { bg: 'bg-amber-900', text: 'text-white', border: 'border-amber-800' },
  black: { bg: 'bg-zinc-900', text: 'text-white', border: 'border-zinc-600' },
};

export const BELT_PHASES = ['white', 'blue', 'purple', 'brown', 'black'];

export const CATEGORY_NAMES = {
  personal_training: 'Personal Training',
  self_defense: 'Self-Defense',
  jiujitsu: 'Jiu-Jitsu',
};

// Map category → trainer per-service price field
export const CATEGORY_PRICE_FIELD = {
  personal_training: 'price_personal_training',
  self_defense: 'price_self_defense',
  jiujitsu: 'price_jiu_jitsu',
};

export const getTrainerPriceForCategory = (trainerProfile, category) => {
  if (!trainerProfile || !category) return null;
  const field = CATEGORY_PRICE_FIELD[category];
  const v = field ? trainerProfile[field] : null;
  if (v !== null && v !== undefined && v !== '' && Number(v) > 0) return Number(v);
  if (trainerProfile.hourly_rate && Number(trainerProfile.hourly_rate) > 0) {
    return Number(trainerProfile.hourly_rate);
  }
  return null;
};

export const VERIFICATION_BADGES = {
  verified: { label: 'Verified', color: 'badge-verified', icon: 'Shield' },
  elite: { label: 'Elite', color: 'badge-elite', icon: 'Award' },
  specialist: { label: 'Specialist', color: 'badge-specialist', icon: 'Star' },
};

// Format currency
export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  }).format(amount);
};

// Format date
export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  });
};

// Format time
export const formatTime = (timeString) => {
  const [hours, minutes] = timeString.split(':');
  const hour = parseInt(hours);
  const ampm = hour >= 12 ? 'PM' : 'AM';
  const hour12 = hour % 12 || 12;
  return `${hour12}:${minutes} ${ampm}`;
};

// Get initials from name
export const getInitials = (name) => {
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
};

// Calculate progress percentage
export const calculateProgress = (current, total) => {
  if (total === 0) return 0;
  return Math.round((current / total) * 100);
};

// Auth helpers — access token is memory-only; only the user object is cached locally
export const setAuthData = (token, user) => {
  setAccessToken(token);
  localStorage.setItem('doorguard_user', JSON.stringify(user));
};

export const getAuthData = () => {
  const token = getAccessToken();
  const userStr = localStorage.getItem('doorguard_user');
  const user = userStr ? JSON.parse(userStr) : null;
  return { token, user };
};

export const clearAuthData = () => {
  setAccessToken(null);
  localStorage.removeItem('doorguard_token');
  localStorage.removeItem('doorguard_user');
};

export const isAuthenticated = () => {
  return !!getAccessToken();
};

// Liability waiver: true when the client has accepted the CURRENT waiver version.
// Backend /auth/me sets `waiver_up_to_date`; fall back to legacy accepted_at flag.
export const waiverOk = (user) => {
  if (!user || user.role !== 'client') return true;
  if (typeof user.waiver_up_to_date === 'boolean') return user.waiver_up_to_date;
  return !!user.client_profile?.liability_waiver_accepted_at;
};
